/**
 * Pure Helfer für die LoginPage — getrennt, damit sie ohne DOM/React testbar sind.
 */

export const EXPIRED_SESSION_MESSAGE = "Session abgelaufen – bitte melden Sie sich erneut an.";

/** Bewusst gespeicherte letzte Login-E-Mail (nur nach ERFOLGREICHEM Login gesetzt). */
export const LAST_LOGIN_EMAIL_KEY = "energyos-last-login-email";

/** Meldung zur `?reason=…`-Query der Login-Seite (null = keine Meldung). */
export function loginNoticeForReason(reason: string | null): string | null {
  return reason === "expired" ? EXPIRED_SESSION_MESSAGE : null;
}

/**
 * Vorbelegung des E-Mail-Felds: leer, außer es wurde bei einem früheren erfolgreichen
 * Login bewusst gespeichert. Kein hartkodierter Seed-/Dev-Default mehr.
 */
export function initialLoginEmail(storage: Pick<Storage, "getItem"> | undefined): string {
  try {
    return storage?.getItem(LAST_LOGIN_EMAIL_KEY)?.trim() ?? "";
  } catch {
    return "";
  }
}

/** Nach erfolgreichem Login: E-Mail als bewusst gespeicherten Last-Used-Wert merken. */
export function rememberLoginEmail(
  storage: Pick<Storage, "setItem"> | undefined,
  email: string,
): void {
  try {
    const trimmed = email.trim();
    if (trimmed) storage?.setItem(LAST_LOGIN_EMAIL_KEY, trimmed);
  } catch {
    // Storage nicht verfügbar — Prefill entfällt dann einfach.
  }
}
